import React from 'react';
import PropTypes from 'prop-types';
import withProps from 'recompose/withProps';

import { Text } from 'components/core/Typography';

import './hourItem.scss';

export const enhance = withProps((props) => ({
	dayName: props.dayNameFormat === 'abbreviated' ? props.dayName.substr(0, 3) : props.dayName
}));

export function FacilityHourItem({
	dayName, dayNameFormat, openTime
}) {
	return (
		<li className="hour-item">
			<Text color="gray" className={`day-name ${dayNameFormat}`}>
				{dayName}
			</Text>
			<Text color="gray" className="open-time">
				{openTime}
			</Text>
		</li>
	);
}

FacilityHourItem.propTypes = {
	/** The name of the day */
	dayName: PropTypes.string,
	/** How the day name should be formatted */
	dayNameFormat: PropTypes.oneOf(['provided', 'abbreviated']),
	/** A string representing the open time. e.g. "10:00AM - 5:00PM" */
	openTime: PropTypes.string.isRequired
};

FacilityHourItem.defaultProps = {
	dayNameFormat: 'provided'
};

export default enhance(FacilityHourItem);
